import React from "react";

const inputBase =
  "w-full rounded-sm border border-line bg-white px-4 py-3 text-[15px] text-charcoal placeholder:text-ink/50 focus:outline-none focus:border-gold focus:ring-1 focus:ring-gold transition-colors duration-200";

const labelBase = "block text-xs font-semibold text-forest mb-2 uppercase tracking-wider";

export const Field = ({ label, required, error, children, className = "" }) => (
  <div className={className}>
    {label && (
      <label className={labelBase}>
        {label} {required && <span className="text-gold">*</span>}
      </label>
    )}
    {children}
    {error && <p className="mt-1.5 text-xs text-destructive font-medium">{error}</p>}
  </div>
);

export const TextInput = React.forwardRef(({ error, ...props }, ref) => (
  <input ref={ref} className={`${inputBase} ${error ? "border-destructive" : ""}`} {...props} />
));
TextInput.displayName = "TextInput";

export const TextArea = React.forwardRef(({ error, rows = 4, ...props }, ref) => (
  <textarea ref={ref} rows={rows} className={`${inputBase} resize-y ${error ? "border-destructive" : ""}`} {...props} />
));
TextArea.displayName = "TextArea";

export const NativeSelect = React.forwardRef(({ error, children, ...props }, ref) => (
  <select ref={ref} className={`${inputBase} ${error ? "border-destructive" : ""} appearance-none bg-[url('data:image/svg+xml;utf8,<svg xmlns=%22http://www.w3.org/2000/svg%22 width=%2216%22 height=%2216%22 viewBox=%220 0 24 24%22 fill=%22none%22 stroke=%22%230D2E1B%22 stroke-width=%222%22><path d=%22M6 9l6 6 6-6%22/></svg>')] bg-no-repeat bg-[right_1rem_center] pr-10`} {...props}>
    {children}
  </select>
));
NativeSelect.displayName = "NativeSelect";

export const RadioPills = ({ options, value, onChange, name, testid }) => (
  <div className="flex flex-wrap gap-3" data-testid={testid}>
    {options.map((opt) => {
      const selected = value === opt;
      return (
        <button
          type="button"
          key={opt}
          onClick={() => onChange(opt)}
          data-testid={`${testid}-${opt.toLowerCase()}`}
          className={`px-5 py-2.5 rounded-sm text-sm font-medium border transition-colors duration-200 ${
            selected
              ? "bg-forest text-white border-forest"
              : "bg-white text-forest border-line hover:border-gold"
          }`}
        >
          {opt}
        </button>
      );
    })}
  </div>
);
